export type ViewModel = {
  stale: boolean
}

export type WbsItemPathViewModel = {
  projectPlanPath: string
} & ViewModel

export type ParentDeliverableViewModel = {
  uuid: string
  code: string
  displayName: string
} & ViewModel

/** パスのViewModel解決: VMがあればその値を使い、なければ旧値にフォールバック */
// TODO: ViewModel移行完了後、旧フィールドへのフォールバックを削除する
export const resolvePathFromViewModel = (
  viewModel: WbsItemPathViewModel | null | undefined,
  legacyPath: string | null | undefined
): { value: string | undefined; stale: boolean } => {
  if (viewModel) {
    return { value: viewModel.projectPlanPath, stale: viewModel.stale }
  }
  return { value: legacyPath ?? undefined, stale: false }
}

/** 親成果物のViewModel解決 */
// TODO: ViewModel移行完了後、旧フィールドへのフォールバックを削除する
export const resolveParentDeliverableFromViewModel = (
  viewModel: ParentDeliverableViewModel | null | undefined,
  legacyName: string | null | undefined
): { value: string | undefined; stale: boolean } => {
  if (viewModel) {
    return { value: viewModel.displayName, stale: viewModel.stale }
  }
  return { value: legacyName ?? undefined, stale: false }
}
